import { render, staticRenderFns } from "./PortfolioWriteDefaultLayout.vue?vue&type=template&id=72433ed8&scoped=true&"
import script from "./PortfolioWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PortfolioWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72433ed8",
  null
  
)

export default component.exports